/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
//import { useHistory } from 'react-router-dom';
//import { HomeToolbar, ClientCard } from './components';
import { HomeToolbar } from './components';
import mockData from './data';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}));

export const HomeList = props => {

  const classes = useStyles();

  //const [products] = useState(mockData);

  return (
    <div className={classes.root}>
      <HomeToolbar />
    </div>
  );
};

export default HomeList;
